import React, {useState} from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, Box,Text, Badge } from '@chakra-ui/react';
import { StyledTableContainer } from "../../../components/Styled/StyledComponents";
import PaginationControls from "../../../Context/PaginationControls/PaginationControls";
import moment from "moment-timezone";



const PaymentsTable = ({ payments, setPayments, dataLoaded, pageNumber, setPageNumber, totalPages, setTotalPages, setRefreshFlag, filterOptions, refetchPaymentsReportData }) => {
    const [error, setError] = useState('');

    if (error) return <Box textAlign="center" my="4">{error}</Box>;
    if (dataLoaded && !payments?.length) return <Box textAlign="center" my="4">No records found.</Box>;

    function paymentStatus(input) {
        if (!input || typeof input !== 'string') {
            return <Badge colorScheme="gray">Cancelled</Badge>;
        }

        const message = input?.toLowerCase();

        const statusMap = [
            { keyword: 'approved', label: 'Success', color: 'green' },
            { keyword: 'insufficient funds', label: 'Insufficient Funds', color: 'orange' },
            { keyword: 'not fully authenticated', label: 'Authentication Failed', color: 'purple' },
            { keyword: 'declined', label: 'Declined', color: 'red' },
            { keyword: 'invalid card number', label: 'Invalid Card Number', color: 'red' },
        ];

        for (const { keyword, label, color } of statusMap) {
            if (message?.includes(keyword)) {
                return <Badge colorScheme={color}>{label}</Badge>;
            }
        }

        return <Badge colorScheme="red">Failed</Badge>;
    }

    function formatToTwoDecimalPlaces(number) {
        if (typeof number !== 'number') {
            return number;
        }
        return number.toFixed(2);
    }

    return (
        <>
            <StyledTableContainer>
                <PaginationControls pageNumber={pageNumber} setPageNumber={setPageNumber} totalPages={totalPages} />
                <Table variant="striped">
                    <Thead>
                        <Tr>
                            <Th>REF</Th>
                            <Th>Customer Names</Th>
                            <Th>Contact Details</Th>
                            <Th>Payment Category</Th>
                            <Th>Amount</Th>
                            <Th>Status</Th>
                            <Th>Date</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {payments?.map(record => (
                            <Tr key={record._id}>
                                <Td>{record?.reference}</Td>
                                <Td>{record?.fullName}</Td>
                                <Td>
                                    <Text>{record?.phone}</Text>
                                    <Text>{record?.email}</Text>
                                </Td>
                                <Td>{record?.paymentType}</Td>
                                <Td>BWP {formatToTwoDecimalPlaces(record?.amount)}</Td>
                                <Td>{paymentStatus(record?.result)}</Td>
                                {/*<Td>{moment(record?.createdDate).format("DD-MM-YYYY")}</Td>*/}
                                <Td title={record?.createdDate}>
                                    {moment(record?.createdDate).tz('Africa/Gaborone').format("DD-MM-YYYY hh:mm:ss A")}
                                </Td>

                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </StyledTableContainer>
        </>
    );
};

export default PaymentsTable;
